import React, { useState, useEffect } from "react";
import styles from "./homeSlider.module.scss";
import { OwlCarousel, Container, CustomContainer } from "../../atoms/DependencyHelper";
import PropTypes from "prop-types";
import CarouselButton from "../../atoms/buttons/carouselButton/CarouselButton";
import { componentResize } from '../../../utils/helperServices';

const HomeSlider = (props) => {
  let cardCarousel;
  const isMobile = componentResize();
  const [previousNavClass, setPreviousNavClass] = useState("");
  const [nextNavClass, setNextNavClass] = useState("");
  const isTwoThird = props.type === "two-third";

  const next = () => {
    if (cardCarousel) {
      cardCarousel.next(600);
    }
  };
  const prev = () => {
    if (cardCarousel) {
      cardCarousel.prev(600);
    }
  };

  const carouselOptions = {
    nav: true,
    autoplay: false,
    animateIn: "animate__fadeIn",
    autoWidth: true,
    lazyLoad: true,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots",
    dotClass: "owl--dot",
    slideBy: 1,
    margin: 16,
    responsive: {
      0: {
        dots: true,
        // mouseDrag: false,
        // touchDrag: true,
        items: 1,
      },
      1024: {
        dots: false,
        mouseDrag: false,
        touchDrag: true,
      },
    },
  };

  const events = {
    onInitialized: function (event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslate: function (event) {
      setCarouselLeftMargin(event);
    },
    onTranslated: function (event) {
      toggleCarouselNavDisabled(event);
    },
    onDragged: function (event) {
        var ele = document.getElementById("tooltip-0");
       
        // var checkTheme = document.getElementsByClassName("owl-theme");
        // var homeSliderElm = document.getElementsByClassName("homeSlider_home-slider__1vSER");
        // var undefinedElm = document.getElementsByClassName("undefined");
        
        // if(homeSliderElm) {
        //   for (let elm of homeSliderElm) {
        //     elm.classList.remove("homeSlider_home-slider__1vSER");
        //   }
        // }

        // if(checkTheme) {
        //   for (let item of checkTheme) {
        //     item.classList.add("owl-drag");
        //   }
        // }

        // if(undefinedElm) {
        //   for (let elm of undefinedElm) {
        //     elm.classList.remove("undefined");
        //   }
        // }

        if(ele) {
            // Temp hot fix
            ele.classList.remove("show");
            ele.classList.add("hide");
        }
    }
  };

  function setCarouselLeftMargin(event) {
    const index = event.item.index;
    const maximum = event.item.count;

    let leftShift="0px";
    if (!isMobile) {
      if (isTwoThird) {
        leftShift = ((index + 2) >= maximum) ? "95px" : "0px";
      } else {
        leftShift = ((index + 3) >= maximum) ? "20px" : "0px";
      }
    }

    event.target.style.paddingLeft = leftShift;
  }

  function toggleCarouselNavDisabled(event) {
    const index = event.item.index;
    const minimum = 0;
    const maximum = event.item.count;

    let previousNav = index <= minimum ? "disabled" : "";
    let nextNav;
    if (isMobile) {
      nextNav = ((index + 1) >= maximum) ? "disabled" : "";
    } else {
      if (isTwoThird) {
        nextNav = ((index + 2) >= maximum) ? "disabled" : "";
      } else {
        nextNav = ((index + 3) >= maximum) ? "disabled" : "";
      }
    }


    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  return (
    <div className={`${styles["home-slider"]} ${props?.className}`}>
      <CustomContainer className={isMobile ? "container-fluid p-0" : "container"}>
        <div className="owl-carousel-wrapper home-carousel">
          <OwlCarousel
            ref={(c) => (cardCarousel = c)}
            options={carouselOptions}
            events={events}
          >
            {props.slideItems.map((owlItem, index, array) =>
              props.children(owlItem, index, array, props.type)
            )}
          </OwlCarousel>
        </div>
      </CustomContainer>
      {!isMobile &&
        <div className="custom-owl--nav">
        <CarouselButton prev handleClick={prev} className={previousNavClass} id="HomeSlider_arrowBackBtn"/>
          <CarouselButton next handleClick={next} className={nextNavClass} id="HomeSlider_arrowNextBtn"/>
        </div>
      }
    </div>
  );
};
HomeSlider.propTypes = {
  type: PropTypes.string,
  children: PropTypes.any,
  slideItems: PropTypes.array,
};

HomeSlider.defaultProps = {
  type: "default",
  slideItems: [],
};

export default HomeSlider;